/**
 * Protokollnummer `JJJJ-NNNNN`, fortlaufend je Jahr (SPEC Kap. 3).
 *
 * Vergeben wird sie serverseitig über einen atomaren DynamoDB-Counter beim
 * Statuswechsel auf `SIGNED`. Offline-Entwürfe tragen bis dahin eine lokale
 * Kennung und werden als „Entwurf" angezeigt.
 */

export const ENTWURF_PRAEFIX = 'ENTWURF-';

export const formatiereProtokollNr = (jahr: number, laufendeNummer: number): string => {
  if (!Number.isInteger(jahr) || jahr < 2000 || jahr > 9999) {
    throw new Error(`Ungültiges Jahr für die Protokollnummer: ${jahr}`);
  }
  if (!Number.isInteger(laufendeNummer) || laufendeNummer < 1 || laufendeNummer > 99_999) {
    throw new Error(`Laufende Nummer außerhalb des gültigen Bereichs: ${laufendeNummer}`);
  }
  return `${jahr}-${String(laufendeNummer).padStart(5, '0')}`;
};

/** Lokale Kennung eines Entwurfs, bis der Server eine echte Nummer vergibt. */
export const entwurfsKennung = (id: string): string =>
  `${ENTWURF_PRAEFIX}${id.slice(0, 8).toUpperCase()}`;

export const istEntwurfsKennung = (nummer: string | null | undefined): boolean =>
  typeof nummer === 'string' && nummer.startsWith(ENTWURF_PRAEFIX);

/** Anzeigeform: echte Nummer oder „Entwurf". */
export const protokollNrAnzeige = (nummer: string | null | undefined): string => {
  if (!nummer) return 'Entwurf';
  return istEntwurfsKennung(nummer) ? 'Entwurf' : nummer;
};

export const zerlegeProtokollNr = (
  nummer: string,
): { jahr: number; laufendeNummer: number } | null => {
  const treffer = /^(\d{4})-(\d{5})$/.exec(nummer);
  if (!treffer) return null;
  return { jahr: Number(treffer[1]), laufendeNummer: Number(treffer[2]) };
};

/** Schlüssel des Jahres-Counters in DynamoDB. */
export const counterSchluessel = (jahr: number): string => `protokollNr#${jahr}`;
